import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import Button from "@app/components/move2Library/Button/Button"
import Page from "@app/components/pageTypes/Page/Page"
import CashregisterUtilitiesModal from "@app/modals/CashregisterUtilitiesModal/CashregisterUtilitiesModal"
import { getPriceString } from "@app/utils/localeUtils"
import { selectFullPrice } from "@app/utils/selectors"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import LoungerSelection from "./LoungerSelection"
import ZoneSelection from "./ZoneSelection"

export default function Page1({ onNext }) {
	const price = useSelector(selectFullPrice)
	const loungerNotSelected = !useSelector("order.loungers.length")

	const { showModal } = useModal()
	return (
		<Page className="pb-0">
			<ContentBody className="px-4" style={{ boxSizing: "border-box" }}>
				<div className="h-100 flex flex-1 mt-4">
					<div className="flex flex-column flex-shrink-0">
						<ZoneSelection />
					</div>
					<div className="pl-6 flex-1">
						<LoungerSelection />
					</div>
				</div>
			</ContentBody>

			<div className="w-100 mt-auto flex flex-justify-between p-4">
				<div>
					<Button style="danger" onClick={() => KioskBridge.execute("cashregister.kiosk.close")}>
						Schliessen
					</Button>
					<Button style="outlined" className="ml-4 primary" onClick={() => showModal(CashregisterUtilitiesModal)}>
						Optionen
					</Button>
				</div>

				<div className="flex flex-center">
					<div className="f1">{getPriceString(price)}</div>
					<Button style="secondary" className="ml-4 primary" onClick={onNext} disabled={loungerNotSelected}>
						Weiter
					</Button>
				</div>
			</div>
		</Page>
	)
}
